import { render, staticRenderFns } from "./fj2.vue?vue&type=template&id=2cc7a65b&scoped=true&"
import script from "./fj2.vue?vue&type=script&lang=js&"
export * from "./fj2.vue?vue&type=script&lang=js&"
import style0 from "./fj2.vue?vue&type=style&index=0&id=2cc7a65b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc7a65b",
  null
  
)

export default component.exports